module.exports = __webpack_public_path__ + "static/media/end-imaging-badge.4f79c07f.svg";